import styled from 'styled-components';

const HomeTemplateStyle = styled.section`
	overflow: visible;

	.news-inner-section {
		margin-bottom: unset !important;
	}

	.wrap-hero-about {
		padding-top: var(--headerFixedHeight);
		background-color: var(--black1000);
		position: relative;

		.background {
			background-color: var(--white1000);
			height: calc(var(--sectionDistance) / 1.5);
			position: relative;
			will-change: transform;

			&:before {
				content: '';
				position: absolute;
				width: 100%;
				height: 100%;
				left: 0;
				top: 1px;
				background-color: var(--white1000);
			}
		}

		.svg-border {
			position: relative;
			top: -1px;
			fill: var(--black1000);
			transform-origin: top;
			width: 100%;
			height: calc(var(--sectionDistance) / 1.5);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeButtonP: var(--sp3x);

		.background {
			height: calc(var(--sectionDistance) / 1.5 + var(--sizeButtonP)) !important;

			&:after {
				content: '';
				position: absolute;
				width: 100%;
				height: var(--sizeButtonP);
				left: 0;
				top: 0;
				background-color: var(--black1000);
			}
		}
		.svg-border {
			top: var(--sizeButtonP) !important;
		}
	}
`;

export default HomeTemplateStyle;
